import { createAsyncThunk } from '@reduxjs/toolkit';
import MeetingNotesAPI from './meetingNotesApi';

export const fetchMeetingNotesThunk = createAsyncThunk(
  'meetingNotes/fetchNotes',
  async (params, { rejectWithValue }) => {
    try {
      return await MeetingNotesAPI.fetchNotes(params);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load meeting notes');
    }
  }
);

export const createMeetingNoteThunk = createAsyncThunk(
  'meetingNotes/createNote',
  async (noteData, { rejectWithValue }) => {
    try {
      return await MeetingNotesAPI.createNote(noteData);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to create meeting note');
    }
  }
);

export const updateMeetingNoteThunk = createAsyncThunk(
  'meetingNotes/updateNote',
  async ({ noteId, updates }, { rejectWithValue }) => {
    try {
      return await MeetingNotesAPI.updateNote(noteId, updates);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update meeting note');
    }
  }
);

export const deleteMeetingNoteThunk = createAsyncThunk(
  'meetingNotes/deleteNote',
  async (noteId, { rejectWithValue }) => {
    try {
      return await MeetingNotesAPI.deleteNote(noteId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to delete meeting note');
    }
  }
);
